import './EnterpriseFooter.css'
import { translations } from '../../data/translations'

const EnterpriseFooter = ({ language }) => {
  const t = translations[language]

  return (
    <footer className="enterprise-footer" role="contentinfo">
      <div className="enterprise-footer__inner">
        <p className="enterprise-footer__line enterprise-footer__line--title">
          {t.ui.footerOrgLine}
        </p>
        <p className="enterprise-footer__line">{t.ui.footerProjectLine}</p>
        <p className="enterprise-footer__line enterprise-footer__line--meta">
          {t.ui.footerCopyrightPrefix}{' '}
          <a href="#" className="enterprise-footer__link">{t.ui.footerPrivacy}</a> -{' '}
          <a href="#" className="enterprise-footer__link">{t.ui.footerImprint}</a>
        </p>
      </div>
    </footer>
  )
}

export default EnterpriseFooter